import { BRAND } from "../../config/constants";

const MiniSpinner = ({color="#fff", size=13}) => {
  const h = size + 4;
  const w = Math.round(size * 0.35);
  const bars = [
    {c: color, d: "0s"},
    {c: color, d: "0.15s"},
    {c: color === "#fff" ? "#8DC63F" : BRAND.green, d: "0.3s"},
    {c: color === "#fff" ? "#8DC63Fcc" : BRAND.green+"cc", d: "0.45s"},
    {c: color, d: "0.6s"},
  ];
  return (
    <span style={{display:"inline-flex",alignItems:"flex-end",gap:2,height:h,verticalAlign:"middle",marginRight:4}}>
      {bars.map((b,i)=>(
        <span key={i} style={{width:w,height:h*0.85,borderRadius:w,background:b.c,display:"inline-block",animation:"bounce 0.9s ease-in-out infinite",animationDelay:b.d}}/>
      ))}
    </span>
  );
};

export default MiniSpinner;

